import { render, staticRenderFns } from "./CisWithDetail.vue?vue&type=template&id=27e16b0f&scoped=true"
import script from "./CisWithDetail.vue?vue&type=script&lang=js"
export * from "./CisWithDetail.vue?vue&type=script&lang=js"
import style0 from "./CisWithDetail.vue?vue&type=style&index=0&id=27e16b0f&prod&lang=css"
import style1 from "./CisWithDetail.vue?vue&type=style&index=1&id=27e16b0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e16b0f",
  null
  
)

export default component.exports